import React, { PropTypes, PureComponent } from 'react';
import { Messagebar } from '../../shared/messagebar/main';
import { Home } from './home/main';
import { Settings } from './settings/main';
import Requests from './requests/main';
import { Pending } from './pending/main';
import Features from './features';

import { LoginBar } from './loginbar/main';
import { Footer } from './footer/main';

import './styles.scss';

export default class UserHub extends PureComponent {
  showNotification() {
    if (this.props.notification) {
      return (
        <Messagebar
          {...this.props.notification.toJS()}
          delNotification={this.props.delNotification}
        />
      );
    }
    return undefined;
  }

  currentActivity() {
    const { activities } = this.props.currentUser;
    return activities ? activities[0] : '';
  }

  showView() {
    switch (this.currentActivity()) {
      case 'request':
        return <Requests {...this.props} showNotification={() => this.showNotification()} />;
      case 'settings':
        return <Settings {...this.props} />;
      case 'pending':
        return <Pending {...this.props} />;
      case 'features':
        return <Features setAndStartTimer={this.props.setAndStartTimer} />;
      case 'home':
      default:
        return <Home {...this.props} />;
    }
  }

  showFooter() {
    const { currentUser } = this.props;
    const activity = this.currentActivity();
    switch (activity) {
      case 'pending':
      case 'features':
        return null;
      default:
        return (<Footer
          {...this.props}
          userLevels={currentUser.userLevels}
          admin={currentUser.admin}
          activity={activity}
          userId={currentUser.id}
        />);
    }
  }

  render() {
    return (
      <div className='user-hub'>
        <LoginBar {...this.props} />

        {this.showView()}

        {this.showFooter()}
      </div>
    );
  }
}

UserHub.propTypes = {
  delNotification: PropTypes.func,
  setAndStartTimer: PropTypes.func,
  currentUser: PropTypes.object,
  notification: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/main.jsx